import { AppConfiguration } from "config";
import { genericGetRequest, genericPostRequest } from "helpers/sf_backend_helper";
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  createCustomerIncidentsError,
  createCustomerIncidentsSuccess,
  getCustomerIncidentsError,
  getCustomerIncidentsSuccess,
  getTimeframeReportingDataError,
  getTimeframeReportingDataSuccess,
} from "./actions";
import {
  CREATE_CUSTOMER_INCIDENTS,
  GET_CUSTOMER_INCIDENTS,
  GET_TIMEFRAME_REPORTING_DATA
} from "./actionTypes";
function* onGetCustomerIncidents(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/customer_incidents`,
      {},
      {
        "Content-Type": "application/json",
        "Authorization": user.token
      })
    yield put(getCustomerIncidentsSuccess(response))
  } catch (error) {
    yield put(getCustomerIncidentsError(error))
  } 
}

function* onCreateCustomerIncidents(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/customer_incidents`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(createCustomerIncidentsSuccess(response))
  } catch (error) {
    yield put(createCustomerIncidentsError(error))
  }
}

function* onGetReportingData(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(

      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/api_timing_stats_by_timeframe`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": user.token,
        }
      }
    )
    yield put(getTimeframeReportingDataSuccess(response, action.payload.profiling_tag_id))
  } catch (error) {
    yield put(getTimeframeReportingDataError(error))
  } 
}

function* StatusMonitorSaga() {
  yield takeEvery(GET_CUSTOMER_INCIDENTS, onGetCustomerIncidents)
  yield takeEvery(GET_TIMEFRAME_REPORTING_DATA, onGetReportingData)
  yield takeEvery(CREATE_CUSTOMER_INCIDENTS, onCreateCustomerIncidents)
}

export default StatusMonitorSaga;
